/**
 * Card configuration for AccountsDashboard.
 * Add new cards here to extend the Accounts dashboard.
 */
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import type { SvgIconComponent } from "@mui/icons-material";

export type AccountsDashboardCard = {
  permission: string;
  icon: SvgIconComponent;
  label: string;
  description: string;
  path: string;
};

export const ACCOUNTS_DASHBOARD_CARDS: AccountsDashboardCard[] = [
  {
    permission: "sabilReceipts.view",
    icon: ReceiptIcon,
    label: "Sabil Receipts",
    description: "View and manage all sabil receipts",
    path: "sabilReceipt",
  },
  {
    permission: "lagatReceipts.view",
    icon: ReceiptIcon,
    label: "Lagat receipts",
    description: "Lagat receipts (also under Raza module)",
    path: "lagatReceipts",
  },
  {
    permission: "bookingReceipts.view",
    icon: ReceiptIcon,
    label: "Booking Receipts",
    description: "View and manage all booking receipts",
    path: "contRcpt",
  },
  {
    permission: "niyaazReceipts.view",
    icon: ReceiptIcon,
    label: "Niyaaz Event Receipts",
    description: "Event (adhoc) niyaaz receipts across all events",
    path: "niyaazReceipts",
  },
  {
    permission: "yearlyNiyaazReceipts.view",
    icon: ReceiptIcon,
    label: "Yearly Niyaaz Receipts",
    description: "Year-based niyaaz receipts",
    path: "yearlyNiyaazReceipts",
  },
  {
    permission: "tallyConfig.view",
    icon: SettingsIcon,
    label: "Tally config",
    description: "Ledger mappings for Tally export",
    path: "tallyConfig",
  },
  {
    permission: "tallyConfig.view",
    icon: AccountBalanceWalletIcon,
    label: "Bank → Tally export",
    description: "Import bank statement credits as Tally Receipt vouchers",
    path: "bankTallyExport",
  },
];
